import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { DpPaginationModule, DpTableModule, Table } from '@docpath/webcomponents';

import { AliasHttpService } from '../../services/alias-http.service';
import { AliasTableService } from './alias-table.service';

@Component({
  selector: 'app-alias-table',
  templateUrl: './alias-table.component.html',
  standalone: true,
  imports: [DpTableModule, DpPaginationModule]
})

export class AliasTableComponent implements OnInit {

  @Input() filters: Filter[] = [];
  @Output() selectedRow = new EventEmitter<void>();
  @Output() tableLoaded = new EventEmitter<Table>();

  table: Table;
  showLoading = false;

  private readonly aliasTableService = inject(AliasTableService);
  private readonly aliasHttpService = inject(AliasHttpService);

  constructor() {
    this.table = this.aliasTableService.initTable();
  }


  ngOnInit(): void {
    this.aliasTableService.aliasLoaded.subscribe(result => {
      this.table.header = this.aliasTableService.initTableHeader();
      this.table.body = this.aliasTableService.initTableBody(result);
    });

    this.aliasHttpService.showLoadingChanged.subscribe(showLoading => {
      this.showLoading = showLoading;
    });

    this.aliasTableService.loadAlias([], 1, 25);

    this.tableLoaded.emit(this.table);
  }
  onChangeCheck(): void {
    this.selectedRow.emit();
  }

  onChangePage(page: number): void {
    this.aliasTableService.loadAlias(this.filters, page);
  }

  onChangePageSize(size: number): void {
    this.aliasTableService.loadAlias(this.filters, 1, size);
  }

  getCurrentPage(): number {
    return this.aliasTableService.getCurrentPage();
  }

  getCurrentSize(): number {
    return this.aliasTableService.getCurrentSize();
  }

  getElements(): number {
    return this.aliasTableService.getElements();
  }

}